/**
 * Port von `Client/Components/Sidebar/IwmSidebarBestellpositionContainer.razor`, seit REQ-27
 * als `Drawer` (REQ-25 §1) statt `SidebarShell`. Die Sichtbarkeit steuert der
 * {@link OrderPositionContainerSidebarProvider}; im Altclient übernimmt das der Singleton
 * `SbOrderPositionContainerService`.
 */

import { ContainerForm } from '@/components/forms/ContainerForm';
import { Drawer } from '@/components/ui';
import type { SidebarPosition } from '@/components/ui/types';

/** Breite der fachlichen Schubladen (REQ-27 §2.1). */
const WIDTH = '720px';

export interface OrderPositionContainerSidebarProps {
  open: boolean;
  containerId: number;
  /**
   * Ohne Wirkung: Die Schublade hängt per Portal am `body` und liegt über der ganzen Seite,
   * nicht in einem `target`. Die Eigenschaften bleiben, weil die Bestellpositionsansicht sie
   * weiter übergibt (REQ-27 §2.1).
   */
  position?: SidebarPosition;
  target?: string;
  onHide(): void;
}

export function OrderPositionContainerSidebar(props: OrderPositionContainerSidebarProps) {
  const hide = () => {
    props.onHide();
  };

  // Geschlossen rendert die Schublade nichts (REQ-25 §1); das Formular lädt deshalb erst
  // beim Öffnen und beginnt bei jedem Öffnen frisch.
  if (!props.open) return null;

  return (
    <ContainerForm
      id={props.containerId}
      onSave={hide}
      onCancel={hide}
      shell={({ title, footer, children }) => (
        <Drawer open title={title} width={WIDTH} footer={footer} onClose={hide}>
          {children}
        </Drawer>
      )}
    />
  );
}

export default OrderPositionContainerSidebar;
